






import Vue from "vue";

export default Vue.extend({
  name: "ImageSize",
  props: {
    imgUrl: {
      type: String,
      required: true
    },
    width: {
      type: Number
    },
    ratio: {
      type: Number
    }
  },
  data() {
    return {
      styleObject: {
        width: `${this.width}px`,
        height: `${this.width * this.ratio}px`
      }
    };
  }
});
